import { updateCameraGroupOrder } from '@/services/ccs.group.service';
import dayjs from 'dayjs';

const state = {
  cameraLayout: [],
  layoutLoading: false,
  activeEvents: [],
  homeSeekStart: null,
  maxRetentionPeriodDays: 30,
  minRetentionDate: dayjs().subtract(30, 'day').valueOf(),
  enterPageLoading: false,
};

// Getter functions
const getters = {};

// Mutations
const mutations = {
  setCameraLayout(state, cameraLayout) {
    state.cameraLayout = cameraLayout;
  },
  setLayoutLoading(state, loading) {
    state.layoutLoading = loading;
  },
  setActiveEvents(state, activeEvent) {
    state.activeEvents = activeEvent;
  },
  setHomeSeekStart(state, data) {
    state.homeSeekStart = data;
  },
  setMaxRetentionPeriodDays(state, days) {
    state.maxRetentionPeriodDays = days;
    state.minRetentionDate = dayjs().subtract(days, 'day').valueOf();
  },
  setEnterPageLoading(state, loading) {
    state.enterPageLoading = loading;
  },
};

// Actions
const actions = {
  async updateCameraOrder({ dispatch, rootState }, payload) {
    try {
      await updateCameraGroupOrder(payload);
      const homeCameraGroups = rootState.common.homeCameraGroups;
      const tag = homeCameraGroups[payload.cameraGroupId];
      const cameraById = rootState.common.cameraById;
      payload.sort.forEach((s) => {
        tag.cameraList[+s.position - 1] = cameraById[+s.cameraId];
      });

      // sort home group camera list by position
      homeCameraGroups[payload.cameraGroupId] = tag;

      dispatch(
        'common/updateCameraGroupOrder',
        { groupId: payload.cameraGroupId, cameraList: tag.cameraList },
        { root: true }
      );
      dispatch(
        'settings/updateCameraGroupOrder',
        {
          groupId: payload.cameraGroupId,
          ids: tag.cameraList.map((c) => c.id),
        },
        { root: true }
      );
    } catch (error) {
      console.error(error);
    }
  },
  setActiveEvents({ commit }, activeEvents) {
    commit('setActiveEvents', activeEvents);
  },
  setHomeSeekStart({ commit }, data) {
    commit('setHomeSeekStart', data);
  },
  setMaxRetentionPeriodDays({ commit }, days) {
    commit('setMaxRetentionPeriodDays', days);
  },
  enterPage({ commit }) {
    commit('setEnterPageLoading', true);
  },
  pageLoaded({ commit }) {
    commit('setEnterPageLoading', false);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
